import * as Sentry from '@sentry/react'
import { SentryInitOptions } from './types'

const ENV = process.env.REACT_APP_ENV || 'dev'

class SentryService {
    isInit = false

    create() {
        if (this.isInit) {
            return
        }
        Sentry.init({
            dsn: 'https://eb1ec3a4c4a2a0ef90050acdbfd83840@sk2.sen7ry.cc/17',
            integrations: [
                new Sentry.BrowserTracing({
                    // 控制哪些域名需要追踪
                    tracePropagationTargets: [/https?:\/\/.*/],
                }),
                new Sentry.Replay({
                    maskAllText: true,
                    blockAllMedia: true,
                }),
            ],
            environment: ENV,
            // Performance Monitoring
            tracesSampleRate: 1.0, // Capture 100% of the transactions
        })

        this.isInit = true
    }

    captureException(error: Error) {
        Sentry.captureException(error)
    }

    init = (params: SentryInitOptions) => {
        Sentry.setUser({
            username: params.userInfo.username,
            id: params.userInfo.id,
        })
        Sentry.setContext(`${ENV}_userContent`, {
            ...params,
            domain: window.location.href,
            Navigator: {
                ...window.navigator,
            },
        })
    }

    report = (obj: Record<string, any>, msg: string) => {
        if (ENV === 'dev') {
            return
        }
        Sentry.addBreadcrumb(obj)
        Sentry.captureException(msg)
    }
}

const errorReport = new SentryService()

export default errorReport
